import {CONFIG} from "../../config";

const actions = {
    openNextEntry({dispatch, state}) {
        dispatch('openEntryAsync', state.inView._entry.next);
    },

    openPreviousEntry({dispatch, state}) {
        dispatch('openEntryAsync', state.inView._entry.prev);
    },

    openEntry({commit, dispatch, state}, entry) {
        commit('setInView', entry);
    },

    openEntryAsync({commit, dispatch, state}, entry) {
        if (state.cache[entry.post_id]) {
            commit('setInView', state.cache[entry.post_id]);
            return;
        }

        dispatch('setLoading', entry);

        fetch(`${CONFIG.rest.entry}/${entry.post_id}`)
            .then(response => response.json())
            .then(data => {
                if (data.length === 0) {
                    throw new Error('No data received. Does the post exist?');
                }

                data._entry = entry;

                commit('setInView', data);

                commit('setCache', {
                    post_id: entry.post_id,
                    data
                });
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch('setLoading', false);
            })

    },

    closeEntry({commit, dispatch}) {
        dispatch('setLoading', false);
        commit('setInView', {});
    },

    setLoading({commit}, state) {
        commit('setLoading', state);
    },
};

export default actions;